<section class="intro-section">
  <div class="container-fluid">
    <div class="col-md-3 hidden-xs hidden-sm outlt-lft-menu">
    </div>
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-6 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1 col-md-offset-3  center oult-main">
          <img src="/assets/img/aramex-logo.jpg" height="40" width="260" />
          <h1>{{ 'pages.outletSelection.pos' | translate }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-md-offset-3 center paddtop5">
          <p class="main-title">{{ 'pages.outletSelection.countryName' | translate }}</p>
        </div>
      </div>
      <app-entity-selection></app-entity-selection>
    </div>

  </div>
</section>
